const PLACEHOLDER_LAST_NAMES = new Set(['pending', '—', '-', '.'])

/**
 * Format a user-facing display name, omitting invite placeholder last names.
 */
export function formatUserDisplayName(firstName, lastName) {
  const first = (firstName || '').trim()
  const last = (lastName || '').trim()
  if (!first && !last) return ''
  if (!last || PLACEHOLDER_LAST_NAMES.has(last.toLowerCase())) return first
  return `${first} ${last}`.trim()
}

/** Read display name from a user object with mixed camelCase/snake_case keys. */
export function getUserDisplayName(user) {
  if (!user) return ''
  if (user.displayName) return user.displayName
  return formatUserDisplayName(
    user.firstName || user.first_name,
    user.lastName || user.last_name
  )
}
